module.exports = {"370782001":"密州街道","370782002":"龙都街道","370782003":"舜王街道","370782101":"枳沟镇","370782102":"贾悦镇","370782105":"石桥子镇","370782108":"相州镇","370782110":"昌城镇","370782111":"百尺河镇","370782112":"辛兴镇","370782114":"林家村镇","370782117":"皇华镇","370782118":"桃林镇","370782400":"诸城经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370782.json
// module id = 1309
// module chunks = 0